import React from "react"
import { Container, Box, Typography } from "@mui/material"

const EventsTable = ({ events }) => {
  const formatDate = (dateString) => {
    // Convert Date string to JS Date format
    const d = new Date(dateString)

    // Get individual values
    const day = d.getDate()
    const month = d.getMonth() + 1 // 0 is January, so add 1 for display on frontend

    return `${day}/${month}`
  }

  const eventsLength = events.length

  return (
    <Container sx={{ marginTop: 4, paddingBottom: 6 }}>
      <Container sx={{ border: `1px solid black` }}>
        {events.map((event, index) => {
          const { title, startTime, destinationUrl, locationReference } = event
          const formattedDate = formatDate(startTime)
          const lastEvent = index + 1 == eventsLength ? true : false

          return (
            <a
              href={destinationUrl}
              style={{
                textDecoration: `none`,
              }}
              target="_blank"
              rel="noopener noreferrer"
              key={title}
            >
              <Box
                sx={{
                  borderBottom: `1px solid ${
                    lastEvent ? "transparent" : "black"
                  }`,
                  marginLeft: { xs: 0.5, md: 3 },
                  marginRight: { xs: 0.5, md: 3 },
                }}
              >
                <Box
                  sx={{
                    marginTop: 0.5,
                    marginBottom: 0.5,
                    paddingTop: 0.5,
                    paddingBottom: 0.5,
                    display: `grid`,
                    gap: 1,
                    gridTemplateColumns: {
                      xs: "1px 15% 35% 1fr 1px",
                      md: "1fr 10% 20% 30% 1fr",
                    },
                    color: `titles.main`,
                    textTransform: `uppercase`,
                    "&:hover": {
                      backgroundColor: `primary.light`,
                      cursor: `pointer`,
                    },
                  }}
                >
                  <Box />
                  <Typography sx={{ textAlign: `right` }}>
                    {formattedDate}
                  </Typography>
                  <Typography>{locationReference.title}</Typography>
                  <Typography>{title}</Typography>
                  <Box />
                </Box>
              </Box>
            </a>
          )
        })}
      </Container>
    </Container>
  )
}

export default EventsTable
